<template>
  <dara-modal
    ref="modal"
    :title="$t('change-your-password')"
    :show-close-button="false"
    v-bind="$attrs"
    v-on="$listeners">
    <template #content>
      <div>
        <div class="mb-3">
          {{ $t('you-should-choose-a-new-password') }}
        </div>
        <dara-input
          v-model="password"
          type="password"
          :placeholder="$t('type-your-new-password')" />
        <br>
        <dara-input
          v-model="confirm_password"
          type="password"
          :placeholder="$t('confirm-your-new-password')" />
      </div>
    </template>
    <template #footer>
      <dara-button
        class="btn btn-primary"
        size="sm"
        @click="confirm()">
        {{ $t('update') }}
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>
import { updateUserInformation } from '@/modules/user/user.service';
import { toastError, toastSuccess } from '@/services/toastService';
import { translate } from '@/services/translate.service';

export default {
  name: 'DaraChangePasswordModal',
  inject: ['userEditVm'],
  data() {
    return {
      password: null,
      confirm_password: null,
    };
  },
  methods: {
    confirm() {
      this.userEditVm.user.password = this.password;
      this.userEditVm.user.password2 = this.confirm_password;

      const specialChars = !!(this.password.match(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+/) && this.password.match(/\d+/));

      if (!this.password) {
        toastError(`${translate('you-need-to-choose-a-new-password')}`);
      } else if (!specialChars) {
        toastError(`${translate('password-must-have-special-chars-and-numbers')}`);
      } else if (this.password.length < 8) {
        toastError(`${translate('password-too-short')}`);
      } else if (this.password !== this.confirm_password) {
        toastError(`${translate('passwords-doesnt-match')}`);
      } else {
        updateUserInformation(this.userEditVm.user)
          .then(() => {
            this.$refs.modal.close();
            this.userEditVm.user.verified = true;
            toastSuccess(`${translate('users-password-updated')}`);
          })
          .catch(() => toastError(`${translate('error-updating-users-password')}`));
      }
    },
  },
};
</script>
